import { TYPE_COLLECTION } from './input-types';
import { PACKAGE_TYPE } from '../constants';

export const id = PACKAGE_TYPE;
export const apiKey = 'PackageTypeId';
export const type = TYPE_COLLECTION;

export const packageFilter = {
  id,
  apiKey,
  type,
};
